import { Drawer, Classes, AnchorButton, Switch, Card } from "@blueprintjs/core";
import { useContext } from "react";
import { BuildNumberContext } from "psg-react-components";

import React from "react";
import { Settings, SettingsContext } from "utils/context";

type Props = {
    open: boolean;
    setOpen: React.Dispatch<React.SetStateAction<boolean>>;
};

const toggles: {
    setting: keyof Settings;
    label: string;
    adminSetting: boolean;
}[] = [
    {
        setting: "showGlobal",
        label: "Show Global",
        adminSetting: false
    },
    {
        setting: "showRunning",
        label: "Show Runnig",
        adminSetting: false
    },
    {
        setting: "debugTraces",
        label: "Debug Traces",
        adminSetting: true
    },
    {
        setting: "verticalOrientation",
        label: "Vertical Orientation",
        adminSetting: false
    }
];

export default function SettingsDrawer({ open, setOpen }: Props) {
    const buildNumber = useContext(BuildNumberContext);
    const [settings, setSettings] = useContext(SettingsContext);

    return (
        <Drawer
            isOpen={open}
            size={"200px"}
            hasBackdrop={true}
            enforceFocus={false}
            title="Settings"
            icon={"settings"}
            onClose={() => setOpen(false)}
        >
            <div className="settings-drawer">
                <AnchorButton
                    href="https://docs.amp.avanade.com/Automation/Automation_Console/AMP_Automation_Console/"
                    target="_blank"
                    icon="help"
                >
                    Documentation
                </AnchorButton>

                <AnchorButton disabled={true} href="/admin" target="_parent" icon="cog">
                    Manage
                </AnchorButton>

                <Card>
                    {toggles.map((t) => (
                        <Switch
                            key={t.setting}
                            checked={settings[t.setting] as boolean}
                            label={t.label}
                            onChange={() => {
                                setSettings((s) => ({ ...s, [t.setting]: !s[t.setting] }));
                            }}
                        />
                    ))}
                </Card>
            </div>

            <div className={Classes.DRAWER_FOOTER}>
                <div className="build-version">
                    <div className="header">Automation Console</div>
                    {buildNumber}
                </div>
            </div>
        </Drawer>
    );
}
